import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

/**
 * RoleRoute - Protects routes based on user role.
 * Wraps route elements in App.js to enforce role-based access.
 * 
 * @param {React.ReactNode} children - The component to render if authorized
 * @param {string[]} allowedRoles - Array of role strings that can access this route
 * 
 * Usage:
 *   <RoleRoute allowedRoles={["Admin"]}>
 *     <AdminOnlyComponent />
 *   </RoleRoute>
 */
export default function RoleRoute({ children, allowedRoles }) {
    const { userRole, roleLoading } = useAuth();

    // Still loading role data — show nothing (PrivateRoute already handles auth loading)
    if (roleLoading) {
        return null;
    }

    // User's role is not in the allowed list — redirect to dashboard home
    if (!allowedRoles.includes(userRole)) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
}
